interface DashboardHeaderProps {}

export const DashboardHeader = ({}: DashboardHeaderProps) => {
  return (
    <div className="bg-white py-8 px-4 shadow-sm border-b border-gray-200 pt-24">
      <div className="max-w-7xl mx-auto">
        <div className="md:flex md:items-center md:justify-between">
          <div className="flex-1 min-w-0">
            <h1 className="text-2xl font-bold primary-text sm:text-3xl sm:truncate">
              Super Admin Dashboard
            </h1>
            <p className="mt-2 secondary-text">
              Manage districts, schools, and administrators across the platform.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
